import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { default as DefaultPagination } from '@material-ui/lab/Pagination';
import './style.css';
const useStyles = makeStyles((theme) => ({
  root: {
    '& > *': {
      marginTop: theme.spacing(2),
    },
  },
}));

export default function Pagination({ page, setPage, totalPages }) {
  const classes = useStyles();

  const handleChange = (event, value) => {
    setPage(value);
  };

  return (
    <div className="pagination-container">
      <div className={classes.root}>
        <DefaultPagination count={parseInt(totalPages)} page={parseInt(page) || 1} onChange={handleChange} siblingCount={1} />
      </div>
    </div>
  );
}
